export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "Помилка ініціалізації",
    "StaticConfigLoader.caption.init": "Ініціалізація",
    "StaticConfigLoader.text.init": "Ініціалізація додатка...",
    "StaticConfigLoader.error.settings": "Не вдалося завантажити налаштування сайту",
    "StaticConfigLoader.error.circuits": "Не вдалося завантажити налаштування служби",
    //app
    "Legal.Localization": "ua",
    "AchievementApp.Navbar.storeTitle": "Store",
    "AchievementApp.Navbar.supportTitle": "Support",
    "Legal.TermsConditions": "Правила та умови",
    "Legal.TermsService": "Обслуговування",
    "Legal.PrivacyPolicy": "Конфіденційність",
    "Legal.CookiesPolicy": "Налаштування cookie",
    "Legal.Copyright": "Усі торгові марки, логотипи й назви брендів належать їх відповідним власникам.",
    "AchievementApp.Navbar.achievement": "Особисте досягнення",
    "AchievementApp.Navbar.userAchievement": "Досягнення користувача",
    "AchievementApp.Navbar.settingsLink": "Налаштування",
    "AchievementApp.Navbar.profileLink": "Профіль",
    "AchievementApp.Navbar.reloginLink": "Повторно авторизуйтесь або змініть обліковий запис",
    "AchievementApp.Navbar.pageTitlePrew": "Досягнення ",
    "AchievementApp.Navbar.pageTitle": "aijin.Net",
    //commonAssets
    "ViewItemDetailed.state.completed": "Завершено",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "Фільтрувати за назвами",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "Мої друзі",
    "UserFriendsList.heading.showMore": "Показати ще",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "Необхідно налаштувати двофакторну авторизацію",
    "LimitedAccountPanel.2step.link": "Детальніше про двофакторну авторизацію",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "Необхідно підтвердити вашу електронну пошту",
    "LimitedAccountPanel.email.link": "Перейти до профілю",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "На ваш обліковий запис діють обмеження у зв'язку з:",
    "LimitedAccountPanel.conclusion": "Після зміни налаштувань безпеки необхідно повністю вийти, а потім знову ввійти в обліковий запис, щоб зміни набрали чинності",
    "LimitedAccountPanel.relogin": "Повторно авторизуватися",
    "EmailVerificationStateIcon.success": "Підтверджений обліковий запис, перевірена електронна пошта",
    "EmailVerificationStateIcon.warning": "Обмежений обліковий запис, електронна пошта не перевірена",
    "EmailVerificationStateIcon.danger": "Обмежений обліковий запис, НЕОБХІДНО перевірити електронну пошту",
    "TwoFactorStateIcon.success": "Обліковий запис захищено двофакторною авторизацією",
    "TwoFactorStateIcon.warning": "Незахищений обліковий запис, двофакторну авторизацію вимкнено",
    "TwoFactorStateIcon.danger": "НЕОБХІДНА двофакторна авторизація",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "Зберегти налаштування",
    "UserSettingDialog.settings": "Налаштування",
    "UserSettingDialog.userSettings": "Користувацькі налаштування",
    "UserSettingDialog.language": "Мова",
    "UserSettingDialog.privacy": "Конфіденційність",
    "UserSettingDialog.allUsers": "Усі користувачі",
    "UserSettingDialog.friendsOnly": "Лише друзі",
    "UserSettingDialog.onlyMe": "Лише я",
    "UserSettingDialog.whoCanView": "Хто може бачити мої досягнення",
    //unlockProgress
    "ViewUnlockProgress.of": " з ",
    "ViewUnlockProgress.achievCompleted": " досягнень завершено",
    "ViewUnlockProgress.myUnlock": "Мої досягнення",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "Шукати за іменем",
    "ViewItemSearch.label.search": "Шукати користувачів",
    "ViewItemSearch.resultNotFound": "Користувача не знайдено",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "Досягнення",
    "ViewItemSearch.stub.empty": "Немає досягнень",
    "ViewItemSearch.stub.emptyCompare_1": "Користувач ",
    "ViewItemSearch.stub.emptyCompare_2": " не має досягнень у цій грі",
    "ViewItemSearch.limitedAccess": "Доступ до досягнень вибраного користувача обмежено",
    "ViewItemSearch.heading.selectGame": "Виберіть гру зі списку",
    "ViewItemSearch.globalstat.opened": "розблоковано у ",
    "ViewItemSearch.globalstat.ofGamers": "% гравців",
    //authentication
    "NotAllowedMessage.caption": "Немає доступу",
    "NotAllowedMessage.body.h1": "Доступ до досягнень",
    "NotAllowedMessage.body.h3": "наразі немає доступу для вашого облікового запису",
    "NotAllowedMessage.relogin": "Змінити обліковий запис",
    "LandingMessage.caption": "Автентифікація",
    "LandingMessage.body": "Заключні перевірки...",
    "TokenExpiredMessage.caption": "Термін дії автентифікації минув",
    "TokenExpiredMessage.body.h3": "Сталася помилка, однак ви ще можете",
    "TokenExpiredMessage.relogin": "Повторно авторизуватися",
    "AuthErrorMessage.caption": "Помилка автентифікації",
    "AuthErrorMessage.body.h1": "Не вдалося перевірити автентифікацію",
    "AuthErrorMessage.body.code": "Код",
    "AuthErrorMessage.body.desc": "Сталася помилка, однак ви ще можете",
    "AuthErrorMessage.relogin": "Повторно авторизуватися",
    "AuthorizationRequiredMessage.caption": "Необхідна автентифікація",
    "AuthorizationRequiredMessage.body.h3.1": "Для входу в обліковий запис",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "спершу необхідно авторизуватися",
    "AuthorizationRequiredMessage.login": "Увійти на Gaijin.Net",
    "CheckingAuthMessage.caption": "Автентифікація",
    "CheckingAuthMessage.body": "Перевірка автентифікації. Будь ласка, зачекайте",
    "AuthorizationRequiredMessageMobile.body.h3.1": "Мобільна версія тимчасово недоступна",
    "AuthorizationRequiredMessageMobile.body.h3.2": "Будь ласка, використовуйте комп'ютерну версію",
    "AuthorizationRequiredMessageMobile.body.h3.3": "Перепрошуємо",
}